import BaseModelRequest from './base/BaseModelRequest';

export default class AddressManagerRequest extends BaseModelRequest {

  getModelName() {
    return 'user_withdrawal_address';
  }

  updateWalletsWhiteList(data) {
    let url = '/' + this.getModelName();
    return this.put(url, data);
  }

  removeWalletsAddress(data) {
    let url = '/' + this.getModelName();
    return this.del(url, data);
  }

  createANewOne(data) {
    let url = '/' + this.getModelName();
    return this.post(url, data);
  }

  getNetworkByCoin(coin) {
    let url = '/coin-supported-networks';
    return this.get(url, {coin});
  }
}
